module.exports = __webpack_public_path__ + "img/architecture-and-city.1d44a7fc.svg";